import { render, staticRenderFns } from "./teamStatistics.vue?vue&type=template&id=0998821c&scoped=true"
import script from "./teamStatistics.vue?vue&type=script&lang=js"
export * from "./teamStatistics.vue?vue&type=script&lang=js"
import style0 from "./teamStatistics.vue?vue&type=style&index=0&id=0998821c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998821c",
  null
  
)

export default component.exports